module.exports = __webpack_public_path__ + "static/media/fa-solid-900.75f38a15.ttf";